<div class="login-page">
    <div class="container app-container">

        <div *ngIf="processando" class="text-center">
            <i class="fa fa-spinner fa-pulse fa-4x"></i>
        </div>

        <div *ngIf="!processando && !senhaEnviada" class="loginbox-v2 col-xs-12">
            <div class="login-card">
                <h1>Criar Senha</h1>
                <hr>
                <div class="login-card-list-icons">
                    <img src="../../../assets/img/login/icon_loja.svg" alt="">
                    <img src="../../../assets/img/login/icon_serviços.svg" alt="">
                    <img src="../../../assets/img/login/Icon_contas.svg" alt="">
                </div>
            </div>
            <div class="text-left login-form">
                <div *ngIf="logotipo != undefined" class="app-logotipo-v2">
                    <img src="{{ logotipo }}" alt="Logotipo">
                </div>
                <form (submit)="makePwd()" method="submit" ngNativeValidate>
                    <div class="panel-primary text-left">
                        <div *ngIf="mainService.loginService.subject !== undefined">
                            <div class="form-group">
                                <div class="input-group" style="width: 100%">
                                    <label>1 - Chave de Acesso:</label>
                                    <input [(ngModel)]="mainService.loginService.subject.principal" name="chaveAcesso"
                                        type="text" class="form-control" placeholder="000 000 000 000 000" uiCartao
                                        required readonly>
                                </div>
                            </div>

                            <div *ngIf="mainService.loginService.subject.principal.substring(3, 4) === ' '"
                                class="form-group">
                                <div class="input-group" style="width: 100%">
                                    <label>2 - Digite o Código de Comunicação:</label>
                                    <input [(ngModel)]="mainService.loginService.subject.communicationCode"
                                        name="communicationCode" type="text" pattern="[0-9]*" class="form-control"
                                        placeholder="000000" required>
                                </div>
                            </div>

                            <div *ngIf="mainService.loginService.subject.principal.substring(4, 5) === ' '">
                                Não há necessidade de criar sua senha!
                            </div>

                            <div
                                *ngIf="mainService.loginService.subject.principal.substring(4, 5) !== ' ' && mainService.loginService.subject.principal.substring(3, 4) !== ' '">
                                Numero de cartão inválido!
                            </div>

                            <div class="col-xs-12 text-center login-form-links">
                                <p *ngIf="mainService.loginService.subject.principal.substring(3, 4) === ' '">
                                    Duvidas para encontrar o codigo ou a chave de acesso?<br>
                                    Clique aqui:
                                    <a class="app-texto-cor-azul" data-toggle="modal" data-target="#myModal" style="color: #17113f;">
                                        CARTÃO
                                    </a>ou
                                    <a class="app-texto-cor-azul" data-toggle="modal" data-target="#myModal2" style="color: #17113f;">
                                        VOUCHER
                                    </a>
                                </p>
                                <button *ngIf="mainService.loginService.subject.principal.substring(3, 4) === ' '"  style="width: 100%;"
                                    class="btn btn-success-v2" type="submit">
                                    Enviar Senha
                                </button>
                                
                                <br><br>
                                
                                <a (click)="router.navigate(['/login'])" class="btn btn-danger-v2" style="width: 100%;">
                                    Cancelar
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="clearfix"></div>
        <div *ngIf="!processando && senhaEnviada" class="col-xs-12 col-md-6 col-md-offset-3">
            <div class="alert alert-success text-center" role="alert">
                <p>Sua nova senha foi enviada para o endereço de email pré-cadastrado! Por favor, verifique sua caixa de
                    emails e clique em Fazer Login</p>
                <button (click)="goToLogin()" style="margin-top: 1em;" class="btn app-btn-best">
                    Fazer Login
                </button>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>

<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <img src="assets/img/fef7954_Criar_Senha.png" alt="" />
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <img src="assets/img/voucher.png" alt="Voucher" />
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/public/makepwd/makepwd.component.html